import React, { useState } from "react";
import { FaAward, FaMedal } from "react-icons/fa";

const Winners = () => {
  const [showAll, setShowAll] = useState(false);

  // Data from JSON
  const allWinners = [
    {
      "rank": 1,
      "team": {
        "id": "abd169e6-6080-4653-89af-28d364338a1b",
        "name": "عرِّب",
        "full_name": "تيم الله كليزي"
      },
      "project": {
        "id": "2a956c91-2438-488f-bbe5-9ee0461fbc9d",
        "short_description": "أداة تفحص جاهزية مواقع الويب لدعم العربية (RTL، SEO، أداء).",
        "github_url": "https://github.com/Taimkellizy/ArabifyByTaimKellizy",
        "demo_url": "https://arabify-by-taim-kellizy.vercel.app/",
        "additional_files": "https://youtu.be/cSARh6cqneY"
      }
    },
    {
      "rank": 2,
      "team": {
        "id": "102ba76a-44fa-4507-bba7-9ce0f9ea16a0",
        "name": "CODEX",
        "full_name": "خالد المرشدي"
      },
      "project": {
        "id": "88579d82-c042-4b4b-809b-d73b62b534a8",
        "short_description": "منصة تعاونية للبرمجة في الوقت الحقيقي.",
        "github_url": "https://github.com/elmoiv/maan",
        "demo_url": "http://mofaex.ddns.net:9000",
        "additional_files": "https://zdkkcuuigxfbtcpopoew.supabase.co/storage/v1/object/public/project-files/uploads/1764466136795_bibz4uduyap.mp4"
      }
    },
    {
      "rank": 3,
      "team": {
        "id": "d9e47ac7-7a62-4fd6-8258-7c365103a82a",
        "name": "El-Gayar"
      },
      "project": {
        "id": "37be94ba-2f05-4cec-90d4-e984a0d6192b",
        "short_description": "AgentsStudio هو نظام ذكي لمراجعة وتحليل الأكواد يعتمد على مجموعة من وكلاء الذكاء الاصطناعي المتخصصين...",
        "github_url": "https://github.com/DeepActionPotential/AgentsStudio",
        "demo_url": null,
        "additional_files": "https://www.youtube.com/watch?v=tg32jfHGvd8"
      }
    },
    {
      "rank": 4,
      "team": {
        "id": "7b1c5e98-95c3-43d5-b417-0d9060c1dbfa",
        "name": "Ai Knight "
      },
      "project": {
        "id": "6e0e27eb-95be-403b-9ee8-a3757998d4fe",
        "short_description": "Cobuild AI منصة تعليمية تعلم البرمجة عبر مشاريع تفاعلية مدعومة بالذكاء الاصطناعي...",
        "github_url": "https://github.com/mohamed-rabee3/Cobuild-AI.git",
        "demo_url": null,
        "additional_files": "https://drive.google.com/file/d/1FeWVi0hfg4k8Y84hpXTQfssl5HXeUf4A/view?usp=sharing"
      }
    },
    {
      "rank": 11,
      "team": {
        "id": "052e234e-ff41-4eef-a5ce-f39773e41213",
        "name": "ILoveAlt+Tab"
      },
      "project": {
        "id": "ff4e11e9-1c77-4692-95f3-4852226a1ad0",
        "short_description": "نقل ميزة Alt+Tab لل browsers",
        "github_url": "https://github.com/georgeibrahim1/Tably-Extension",
        "demo_url": "https://chromewebstore.google.com/detail/tably-alt-tab-for-your-br/ickleaddhmajeejcihdncfkkmcobbnag?authuser=1&hl=en",
        "additional_files": "https://youtu.be/HQN5BoA2YeI?si=yd_u10oxKEdU5s5d"
      }
    },
    {
      "rank": 5,
      "team": {
        "id": "1da209ae-3703-48d2-916b-6f7312549b6b",
        "name": "البُحْتُرِيْ"
      },
      "project": {
        "id": "3078e9a2-e2ac-47f1-8cb4-0a7e77347618",
        "short_description": "أداة لمساعدة المبرمجين للعثور على مشاكل مخفية أو من الصعب العثور عليها في برامجهم",
        "github_url": "https://github.com/lubbaragaki/asteroid",
        "demo_url": "https://asciinema.org/a/rosfoDGUTt9Qr14RDLZO2Gkod",
        "additional_files": "https://youtu.be/ShY0eEt3yL8"
      }
    },
    {
      "rank": 6,
      "team": {
        "id": "add8e753-1b53-4972-b1d5-069dcba4ca18",
        "name": "QuestFlow"
      },
      "project": {
        "id": "2b97eb6c-dfaf-4294-bbbf-af490bc1baae",
        "short_description": "موقع المرشِد هو منصة تساعد أي شخص عنده فكرة، إنه يحوّلها لخطة مشروع كاملة بشكل تلقائي...",
        "github_url": "https://github.com/Othman1-hub/AlMurshid.git",
        "demo_url": "https://al-murshid.vercel.app/",
        "additional_files": "https://drive.google.com/drive/folders/1mnkcpdk0q-HcXGK78kCKfMpnOLwbuxIE?usp=sharing"
      }
    },
    {
      "rank": 7,
      "team": {
        "id": "c5086b4b-d273-4788-8cd5-4916a444c573",
        "name": "Haddad Team"
      },
      "project": {
        "id": "90202237-b560-4865-8dc5-98c213996198",
        "short_description": "Arabic Localization Helper هي أداة أتمتة لترجمة مشاريع الويب وReact للّغة العربية...",
        "github_url": "https://github.com/AhmedEl-hadad/Arabic-Localization-Helper",
        "demo_url": "https://github.com/AhmedEl-hadad/Arabic-Localization-Helper",
        "additional_files": "https://youtu.be/0SjbTl-rwh4?si=oUvDy4PqIS6dFKio"
      }
    },
    {
      "rank": 8,
      "team": {
        "id": "0f3ca740-16bb-4412-8abc-920eeabc7979",
        "name": "The “Will Fix Later” Gang"
      },
      "project": {
        "id": "859f03da-e24d-4062-8ff1-805ce7201a5d",
        "short_description": "منصّة عربية تهدف لتعليم البرمجة التنافسية...",
        "github_url": "https://github.com/AAAtroush/Another-CP-Helper",
        "demo_url": "https://aaatroush.github.io/Another-CP-Helper/",
        "additional_files": "https://www.youtube.com/watch?v=IHmYI6UuyEM"
      }
    },
    {
      "rank": 9,
      "team": {
        "id": "38b3f544-ac1d-4d9a-b35c-b51dbe156899",
        "name": "Bugsweepers"
      },
      "project": {
        "id": "324fa2de-94ac-43d4-82dc-3dae84731837",
        "short_description": "Bugsweeper is an agentic tool designed to give vibe coders, students, and developers total control over their software...",
        "github_url": "frontend:https://github.com/kevinmahrous/bugsweeper | backend: https://github.com/omarequalmars/bugsweeper-promax3000",
        "demo_url": "https://bugsweeper.vercel.app/",
        "additional_files": "https://drive.google.com/file/d/1QkfinXgU2OXNS9Yy3NZpG7UItVnWfO0M/view?usp=drive_link"
      }
    },
    {
      "rank": 10,
      "team": {
        "id": "8799cc89-e7c8-4ccb-b2e9-a801ccb33081",
        "name": "Night Hunter"
      },
      "project": {
        "id": "0e6a9da5-b960-4eca-9c5b-d22b66c9eff7",
        "short_description": "المشروع هو منصة ذكية لمراجعة وتعلّم البرمجة للمبرمجين العرب...",
        "github_url": "https://github.com/Mohamed7569x/DocQuiz-Qimma/",
        "demo_url": "https://qimma.alsalam-company.com/",
        "additional_files": "https://youtu.be/EYZgU_xiRd0"
      }
    },
    {
      "rank": 13,
      "team": {
        "id": "add562d8-0979-49e3-a4e4-a0b7d6484649",
        "name": "MOASM"
      },
      "project": {
        "id": "52d1ee26-b2e0-429d-ac91-ffb173fa64e0",
        "short_description": "MAOSM (Multi-Agent Orchestrator with Semantic Memory) هو نظام متطور...",
        "github_url": "https://github.com/hadywalied/maosm",
        "demo_url": null,
        "additional_files": "https://drive.google.com/file/d/1G4j4Js9lJoSOHURtohaRcOeMp8N2cx5V/view?usp=sharing"
      }
    },
    {
      "rank": 14,
      "team": {
        "id": "38395a78-a28f-4f2d-b8bb-2eb646009b0f",
        "name": "Aery"
      },
      "project": {
        "id": "4f5cbc14-5a93-4c80-befc-c5cde650bdeb",
        "short_description": "مشروع يربط بين المستثمرين و المطورين...",
        "github_url": "https://github.com/HeyItsToraBora/Startony",
        "demo_url": null,
        "additional_files": "https://youtu.be/bNLByuPW0dY"
      }
    },
    {
      "rank": 12,
      "team": {
        "id": "5045bdc8-1c07-41ce-8142-5fc660e69760",
        "name": "BestCode"
      },
      "project": {
        "id": "683468b1-87f4-4be5-af0d-656bcaed786e",
        "short_description": "احنا بنقدم منصه بتجمع ال Best practices عشان نساعد بيها الديفيلوبرز...",
        "github_url": "https://github.com/saver711/webdox",
        "demo_url": "https://ahworks.xyz",
        "additional_files": "https://drive.google.com/drive/folders/1_9-jB8chb72cPKNOgNz26bG6RCyq2d5p?usp=sharing"
      }
    },
    {
      "rank": 15,
      "team": {
        "id": "a04d28dc-ca50-4ad1-8143-12e297c0ff5e",
        "name": "بايروسول"
      },
      "project": {
        "id": "d1283389-b553-4e0a-a2d4-9842db9e0790",
        "short_description": "Haykal is a UI system meant for those that want to do UI...",
        "github_url": "https://github.com/el-lob0/haykal.git",
        "demo_url": "https://github.com/el-lob0/haykal/blob/master/test/build/test",
        "additional_files": "https://youtu.be/Ni9Ujs6qKX4"
      }
    },
    {
      "rank": 16,
      "team": {
        "id": "76eaf5f5-fafa-4086-979f-25fe602f910a",
        "name": "Aery Opps (we will defeat them)"
      },
      "project": {
        "id": "e27bcdaa-57e1-4a02-8af2-732ed64cd4d1",
        "short_description": "مشروع جامع لأدوات كثير صغيرة تساعد المبرمجين و المطورين...",
        "github_url": "https://github.com/HeyItsToraBora/devtools",
        "demo_url": null,
        "additional_files": "https://www.youtube.com/watch?v=j91lSXEjxFE&list=PL9ES3B4paDqK_Urma763mYw5ti5DmhkB9"
      }
    },
    {
      "rank": 18,
      "team": {
        "id": "7feaf411-ae82-4900-86ea-6629956770f5",
        "name": "Spider man"
      },
      "project": {
        "id": "521d6950-bd4a-4045-a3bc-fcb46965c490",
        "short_description": "ساعد مبرمج هو ويب ابب بيساعد علي حل بعض المشاكل...",
        "github_url": "https://github.com/Mo2men-A/sa3edmobrmeg-f-qemma",
        "demo_url": "https://sa3edmobrmeg-f-qemma.vercel.app/",
        "additional_files": "https://youtu.be/qAJy6GfAe2Q"
      }
    },
    {
      "rank": 19,
      "team": {
        "id": "b32684cf-3ae6-4346-9e22-45819d448f81",
        "name": "الحافوزليق"
      },
      "project": {
        "id": "ae33e26b-819c-483d-94f3-e01991059730",
        "short_description": "الـ motivation بتاع الفكرة هو مقولة you don't know what you don't know...",
        "github_url": "https://github.com/omarmohamed286/fill-in",
        "demo_url": "https://fill-in.vercel.app/",
        "additional_files": "https://www.youtube.com/watch?v=og7TGSvZoVk"
      }
    },
    {
      "rank": 20,
      "team": {
        "id": "80d6ac6f-cb64-4c9d-8959-3030b4e4ae42",
        "name": "Statui"
      },
      "project": {
        "id": "53b86233-35db-47be-ba09-7323d3810020",
        "short_description": "API health check TUI dashboard built with Rust and Ratatui",
        "github_url": "https://github.com/Mohamed-Badry/statui",
        "demo_url": "https://crates.io/crates/statui",
        "additional_files": "https://youtu.be/aUcO7zaWQ3A"
      }
    },
    {
      "rank": 17,
      "team": {
        "id": "04915fe8-4fcc-4aa0-a5f4-814789a5fa04",
        "name": "BrmgIDE"
      },
      "project": {
        "id": "6a618244-9a18-4396-a548-6746558affc9",
        "short_description": "موقع تعليم برمجة باللغة العربية تفاعلي فيه IDE...",
        "github_url": "https://github.com/Maqed/BrmgIDE",
        "demo_url": "https://brmgide.pages.dev/ar",
        "additional_files": "https://youtu.be/SYpJ9v4L7Uc"
      }
    },
    {
      "rank": 21,
      "team": {
        "id": "d338e454-ddd5-4ff1-9b72-20bf812f4944",
        "name": "PABLO"
      },
      "project": {
        "id": "38a9206b-c25e-481f-93f3-2446dcd15838",
        "short_description": "Gitbusted هو نظام مفتوح المصدر يهدف إلى كشف الاستلال والنسخ...",
        "github_url": "https://github.com/GitBusted/Gitbusted-Pub",
        "demo_url": null,
        "additional_files": "https://youtu.be/PLoS0WJ_9QQ?si=2e3OJ4KsaJPGtlRD"
      }
    },
    {
      "rank": 22,
      "team": {
        "id": "646b0f5d-980f-42d4-8fd5-f6a5918ea673",
        "name": "EagleEye's team"
      },
      "project": {
        "id": "8105a2f4-b838-4123-ab32-b8b7cd92db64",
        "short_description": "مشروعنا عباره عن Anti-cheat تقدر تدمجو مع ابلكيشن او لعبة...",
        "github_url": "https://github.com/ShehabAhmed-Gui/eagle-eye-client",
        "demo_url": null,
        "additional_files": "https://drive.google.com/file/d/12Ymnu3NnCHzxOKwUSrrMYHB20yToTqJz/view?usp=sharing"
      }
    },
    {
      "rank": 23,
      "team": {
        "id": "7659b9b8-f617-4700-ad3d-0c722017f722",
        "name": "ArabicSec"
      },
      "project": {
        "id": "774c4a47-5ab9-4a5e-a0d7-42699d54d000",
        "short_description": "هدفنا إننا نعمل أكبر منصة تعليم أمن سيبراني في الوطن العربي...",
        "github_url": "https://github.com/shefoo-om/ArabicSec-Qimma",
        "demo_url": "https://arabicsec11.netlify.app/",
        "additional_files": "https://drive.google.com/drive/folders/10KT6kMsyZYxWInrIPcQ-tRD3dTtgmH2b?usp=sharing"
      }
    },
    {
      "rank": 24,
      "team": {
        "id": "fe618857-4a88-424e-9521-fff64927f2d2",
        "name": "HAWIAH حاوية"
      },
      "project": {
        "id": "d8be86b3-b09d-4b61-9a97-8d3f789b220f",
        "short_description": "Hawiah هي طبقة DAL لقواعد البيانات، معيارية وخفيفة الوزن...",
        "github_url": "https://github.com/Shuruhatik/hawiah",
        "demo_url": "https://hawiah.shuruhatik.com/",
        "additional_files": "https://drive.google.com/file/d/1OWSbMj7scDhE7jOvJ1ENw3yXIj7N83u5/view?usp=sharing"
      }
    },
    {
      "rank": 25,
      "team": {
        "id": "9f39f73c-de5b-4c58-94ef-55ffc525c58e",
        "name": "clementine"
      },
      "project": {
        "id": "a45fd8b4-1f77-4fea-b073-6cb102eff7cd",
        "short_description": "مشروعي هو منصة تعليمية قابلة للتوسع، هدفها تبسيط تعلم البرمجة للكل...",
        "github_url": "https://github.com/majidkawouk/Clementine",
        "demo_url": "https://clementine-alpha.vercel.app/",
        "additional_files": "https://youtu.be/TR_kCLiykls?si=x6r7GEZVDkSTgQ0K"
      }
    },
    {
      "rank": 26,
      "team": {
        "id": "acef046f-a316-414b-9fba-89e22062a11f",
        "name": "M.T(Masar Tech)"
      },
      "project": {
        "id": "7cae5a88-df85-40f7-9420-e2b3a6b61c20",
        "short_description": "منصة عربية لتعلّم البرمجة – نسخة أولية.",
        "github_url": "https://github.com/wardaabdelmoniem55-alt/-MVP-",
        "demo_url": " https://wardaabdelmoniem55-alt.github.io/-MVP-/",
        "additional_files": "https://drive.google.com/file/d/1yh6xNUXtwxhulJFY45_auo0AXNfPyXga/view?usp=drive_link"
      }
    },
    {
      "rank": 27,
      "team": {
        "id": "71cee8e0-7c7e-4536-9e4a-f062a8ca5ddf",
        "name": "مسار"
      },
      "project": {
        "id": "dc60f5a9-99f0-4234-b2f9-8ec0b58e606d",
        "short_description": "المشروع هو عبارة عن منصة تحتوي على وظائف من جميع مواقع التوظيف...",
        "github_url": "https://github.com/xelafares/Masar",
        "demo_url": null,
        "additional_files": "https://youtu.be/gNHxl598s3A"
      }
    },
    {
      "rank": 28,
      "team": {
        "id": "a306ba8a-4cd9-4f7d-b977-f89abeac0660",
        "name": "2To1"
      },
      "project": {
        "id": "71dad5ae-8525-4cdd-94d2-c15c1e8e729e",
        "short_description": "تطبيق هاتف يوفر اخر اخبار المجتمع البرمجي و road maps...",
        "github_url": "https://github.com/ziadg168-wq/2To1",
        "demo_url": "https://drive.google.com/drive/folders/1qhDQ4vjSqtkSN6npc_tjBwgHMbYzqHeu",
        "additional_files": "https://drive.google.com/drive/folders/1qhDQ4vjSqtkSN6npc_tjBwgHMbYzqHeu"
      }
    },
    {
      "rank": 29,
      "team": {
        "id": "a12fa80a-2875-4813-93b9-baec0e43bf7f",
        "name": "Rat-team"
      },
      "project": {
        "id": "da9ccc33-0af2-436c-bf52-75a269417a86",
        "short_description": "Flow is a simple desktop app that reminds you to drink water...",
        "github_url": "https://github.com/Evil-Rat/Flow-Water-Reminder",
        "demo_url": "https://github.com/Evil-Rat/Flow-Water-Reminder/releases/tag/v1.0",
        "additional_files": "https://drive.google.com/file/d/1sIY7XEDTb4eILzJKOFDSpJXTF8uP4pfU/view?usp=sharing"
      }
    },
    {
      "rank": 30,
      "team": {
        "id": "55dd4e6d-553c-44b5-aba1-03c950f3adc4",
        "name": "neRIA STUDIO"
      },
      "project": {
        "id": "621a9836-98d8-425c-8320-c03e86950a25",
        "short_description": "A StackOverflow copy where developers and tech people in general...",
        "github_url": "https://github.com/IamFastre/Fussr",
        "demo_url": "https://fussr.neria.studio",
        "additional_files": "https://youtu.be/1wavy17omc0"
      }
    },
    {
      "rank": 31,
      "team": {
        "id": "7feaf411-ae82-4900-86ea-6629956770f5",
        "name": "Spider man"
      },
      "project": {
        "id": "ebdbd893-280d-4daf-aef7-30d323b54f21",
        "short_description": "لسيلسي",
        "github_url": "https://github.com/Mo2men-A/sa3edmobrmeg-f-qemma",
        "demo_url": "https://sa3edmobrmeg-f-qemma.vercel.app/",
        "additional_files": "https://youtu.be/qAJy6GfAe2Q"
      }
    },
    {
      "rank": 32,
      "team": {
        "id": "4e3c11b6-1376-42d1-857f-c4e7e7cca3bc",
        "name": "Crimsonide"
      },
      "project": {
        "id": "eba129db-53c8-4ab3-a916-c93dcaa23c8a",
        "short_description": "المشروع عبارة عن تطبيق لمراقبة وضعية الجلوس وتنبيه المستخدم إذا جلس بشكل خاطئ",
        "github_url": "https://github.com/CrimsonSteel/Mozannab",
        "demo_url": "https://drive.google.com/file/d/17iProyaYpT1eXouRXEikdwzad0wfwe18/view",
        "additional_files": "https://drive.google.com/file/d/1PpifioApWyrHAlad8BWy6fAP-sNpgYua/view?usp=sharing"
      }
    },
    {
      "rank": 33,
      "team": {
        "id": "de480454-3d5c-4670-8596-3e9164c14207",
        "name": "manipulator"
      },
      "project": {
        "id": "f15ac68c-7110-4ac1-89f5-b02511a6d2d1",
        "short_description": "YA3YONI desktop application - عشان عينك مهمة، كل 20 دقيقة ابليكيشن \"يعيوني\" هيفكرك انك تغمض عينك...",
        "github_url": "https://github.com/arwa-28/YA3YONI.git",
        "demo_url": "https://github.com/arwa-28/YA3YONI/releases/tag/v1.0.0",
        "additional_files": "https://drive.google.com/file/d/1kyGGK-7nOj6DyWeGtLU4k09f2u2O8Nrr/view?usp=sharing"
      }
    },
    {
      "rank": 34,
      "team": {
        "id": "c7f8cb74-0b01-4e01-b7e4-6fbf9a2ade1b",
        "name": "Prototype"
      },
      "project": {
        "id": "0a3c7f87-bd7d-4e85-9fb4-f89bc7d5aa94",
        "short_description": "المشروع بأختصار شديد عباره عن نسخه جيت هب. تطبيق باللغه العربيه...",
        "github_url": "https://github.com/Relizu/Github-Gallery-GUI/",
        "demo_url": null,
        "additional_files": "https://youtu.be/-WBwaqC43dE"
      }
    },
    {
      "rank": 35,
      "team": {
        "id": "c44b645d-bb75-46f6-adda-7e187def78af",
        "name": "realll-1"
      },
      "project": {
        "id": "cba6a7f8-6145-4e9c-8268-7dfacac1b6bb",
        "short_description": "شروعي عباره عن تطبيق لحساب المصروفات والمدخلات الخاصه بالمستخدم ",
        "github_url": "https://github.com/Abdelrhman-Anas/money-tracker-web-app",
        "demo_url": null,
        "additional_files": "https://youtu.be/2Ps1wtgIqM8"
      }
    }
  ];

  const firstPlace = allWinners.find(w => w.rank === 1);
  const creativeAward = allWinners.find(w => w.rank === 2);
  
  // List starts from rank 3 to 10 by default
  const displayedWinners = showAll 
    ? allWinners.filter(w => w.rank > 2) 
    : allWinners.filter(w => w.rank > 2 && w.rank <= 10);

  return (
    <section
      id="winners"
      className="relative py-16 md:py-24 bg-dark-blue overflow-hidden"
    >
      <div className="container mx-auto px-6 md:px-12 relative z-10">
        <div className="max-w-6xl mx-auto">
          {/* Section Title */}
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4 uppercase tracking-wide">
              الفائزين
            </h2>
            <div className="w-24 h-1 bg-yellow mx-auto rounded-full mb-4"></div>
            <p className="text-white/80 text-lg">
              المشاريع المتميزة التي تألقت في هاكاثون قمة
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-4 gap-8 mb-16">
            {/* First Place Card */}
            <div className="lg:col-span-2 relative group">
              <div className="relative h-full border-4 border-yellow bg-blue rounded-3xl p-8 md:p-12 flex flex-col justify-center items-start text-start shadow-[0_0_30px_rgba(255,198,0,0.15)] transition-transform hover:scale-[1.01]">
                <div className="absolute -top-5 left-1/2 transform -translate-x-1/2">
                  <span className="bg-yellow text-blue font-bold px-8 py-2 rounded-full text-base lg:text-xl shadow-lg uppercase tracking-wider flex items-center gap-2">
                    <FaMedal className="h-6 w-6" />
                    المركز الأول
                  </span>
                </div>
                {/* prize amount */}
                <span className="text-white text-center mx-auto text-xl leading-relaxed line-clamp-3 mb-4">
                بجائزة <span className="text-yellow font-bold">$500</span>
                </span>
                <h3 className="text-3xl mb-4 text-start font-bold text-white mt-8">
                  {firstPlace.team.full_name} - <span className="text-yellow font-bold">{firstPlace.team.name}</span>
                </h3>
                <p className="text-white/80 text-start text-base leading-relaxed line-clamp-3 mb-4">
                  {firstPlace.project.short_description}
                </p>
                <a
                  href={firstPlace.project.additional_files || firstPlace.project.github_url}
                  target="_blank"
                  rel="noreferrer"
                  className="text-lg text-yellow hover:text-white transition-colors font-semibold underline decoration-2 underline-offset-8 mt-auto block"
                >
                  عرض المشروع
                </a>
              </div>
            </div>

            {/* Creative Award Card */}
            <div className="lg:col-span-2 relative">
              <div className="h-full border-2 border-yellow bg-blue/50 rounded-3xl p-8 lg:p-12 flex flex-col justify-center items-start text-start hover:bg-blue transition-colors duration-300">
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 w-max">
                  <span className="bg-blue border border-yellow text-yellow font-bold px-6 py-1.5 rounded-full text-sm shadow-lg flex items-center gap-2">
                    <FaAward
                      className="h-6 w-6"
                    />
                    جائزة الإبداع
                  </span>
                </div>
                {/* prize amount */}
                <span className="text-white text-center mx-auto text-xl leading-relaxed line-clamp-3 mb-4">
                بجائزة <span className="text-yellow font-bold">$50</span>
                </span>
                <h3 className="text-3xl text-start font-bold text-white mt-8 mb-2">
                  {creativeAward.team.full_name} - <span className="text-yellow font-bold">{creativeAward.team.name}</span>
                </h3>
                <p className="text-white/80 text-start text-base leading-relaxed line-clamp-3 mb-4">
                  {creativeAward.project.short_description}
                </p>
                <a
                  href={creativeAward.project.additional_files || creativeAward.project.github_url}
                  target="_blank"
                  rel="noreferrer"
                  className="text-lg text-yellow hover:text-white transition-colors font-semibold underline decoration-2 underline-offset-8 mt-auto block"
                >
                  عرض المشروع
                </a>
              </div>
            </div>
          </div>

          {/* Other Winners List */}
          <div className="bg-blue/30 border border-white/10 rounded-2xl p-8 backdrop-blur-sm">
            <div className="flex flex-wrap justify-center gap-4 md:gap-8">
              {displayedWinners.sort((a, b) => a.rank - b.rank).map((winner) => (
                <a
                  key={winner.rank}
                  href={winner.project.additional_files || winner.project.github_url}
                  target="_blank"
                  rel="noreferrer"
                  className="flex items-center gap-3 bg-blue/50 hover:bg-yellow hover:text-blue text-white px-5 py-3 rounded-xl transition-all duration-300 group border border-white/5 hover:border-yellow min-w-[200px]"
                >
                  {winner.rank < 11 && (
                  <span className="flex items-center justify-center w-8 h-8 rounded-full bg-white/10 group-hover:bg-blue/20 text-sm font-bold flex-shrink-0">
                    {winner.rank}
                  </span>
                  )}
                  <span className="font-medium text-lg truncate max-w-[150px]">{winner.team.name}</span>
                </a>
              ))}
            </div>
            
            {/* Show More Button */}
            {!showAll && (
              <div className="text-center mt-8">
                <button
                  onClick={() => setShowAll(true)}
                  className="bg-transparent border-2 border-yellow text-yellow hover:bg-yellow hover:text-blue font-bold py-2 px-6 rounded-full transition-all duration-300"
                >
                  عرض باقي المشاريع ({allWinners.length - 10})
                </button>
              </div>
            )}
             {showAll && (
              <div className="text-center mt-8">
                <p className="text-white/60 text-sm mb-4">
                  ملاحظة: المشاريع بعد المركز العاشر غير مرتبة (ترتيب عشوائي)
                </p>
                <button
                  onClick={() => setShowAll(false)}
                  className="bg-transparent border-2 border-white/30 text-white/60 hover:bg-white/10 hover:text-white font-bold py-2 px-6 rounded-full transition-all duration-300"
                >
                  عرض أقل
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Winners;
